(ns practitest.frontend.search.main
  (:require [practitest.frontend.components2.spinners :as spinners]
            [practitest.frontend.common-old-fe.i18n :as i18n]
            [practitest.frontend.search.events]
            [practitest.frontend.search.subs]
            [practitest.frontend.search.views :as views]
            [re-frame.core :as re-frame]
            [re-frame.db]))

(defn search-view []
  (if-let [_init-done? @(re-frame/subscribe [:search/init-complete?])]
    [views/main-panel]
    [:div.loader
      [spinners/mux-spinner {:size :modal}]]))

(defn ^:export legacy-init [config translation]
  (i18n/initialize (js->clj translation :keywordize-keys true))
  (re-frame/dispatch [:search/initialize (js->clj config :keywordize-keys true)])
  (re-frame/dispatch [:search/get-users])
  (re-frame/dispatch [:search/init-complete]))
